import { createColumnHelper } from '@tanstack/react-table';
import { Badge } from 'react-bootstrap';
import { ClientService } from '../../../../../services/clientService';
import { decodeJWT } from '../../../../../services/candidateService';
import _ from 'lodash';

const getBadge = (status) => {
  const badgeMap = {
    ACTIVE: 'success',
    INACTIVE: 'danger',
  };
  return _.get(badgeMap, status, 'secondary');
};
export const prepareClientData = (
  clientData,
  callback1 = null,
  callback2 = null,
  callback3 = null,
  fromPopup = false
) => {
  const data = clientData?.data?.clients;
  const columnHelper = createColumnHelper();

  const decoded = decodeJWT(window.localStorage.getItem("authToken"));
  const currentUserRole = decoded?.roles;

  const isPopupMode = fromPopup === true;
  const handleClientSelect = isPopupMode ? callback1 : null;

  const setSelectedClient = !isPopupMode ? callback1 : null;
  const setShowModal = !isPopupMode ? callback2 : null;
  const setIsActivateAction = !isPopupMode ? callback3 : null;
  const columns = [
    columnHelper.accessor((row) => row.clientId, {
      id: "clientId",

      cell: (info) =>
        isPopupMode ? (
          <span
            style={{ color: "blue", textDecoration: "underline", cursor: "pointer" }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleClientSelect?.(info.row.original);
            }}
          >
            {info.getValue()}
          </span>
        ) : (
          <a href={`/update-client?clientId=${info.getValue()}`}>
            {info.getValue()}
          </a>
        ),

      header: () => <span>Client ID</span>,
    }),
    columnHelper.accessor('companyName', {
      id: 'companyName',
      cell: (info) => (
        <div className="truncate" style={{ maxWidth: 220 }}>
          {info.getValue()}
        </div>
      ),
      header: () => <span>Company Name</span>,
    }),
    columnHelper.accessor('industry', {
      id: 'industry',
      cell: (info) => (
        <div className="truncate" style={{ maxWidth: 220 }}>
          {info.getValue()}
        </div>
      ),
      header: () => <span>Industry</span>,
    }),
    columnHelper.accessor('contactPerson.name', {
      id: 'contactPerson.name',
      cell: (info) => (
        <div className="truncate" style={{ maxWidth: 220 }}>
          {info.getValue()}
        </div>
      ),
      header: () => <span>Contact Person</span>,
    }),
    columnHelper.accessor('contactPerson.phoneNumber', {
      id: 'contactPerson.phoneNumber',
      cell: (info) => (
        <div className="truncate" style={{ maxWidth: 220 }}>
          {info.getValue()}
        </div>
      ),
      header: () => <span>Contact No.</span>,
    }),
    columnHelper.accessor('contactPerson.emailId', {
      id: 'contactPerson.emailId',
      cell: (info) => (
        <div className="truncate" style={{ maxWidth: 220 }}>
          {info.getValue()}
        </div>
      ),
      header: () => <span>Email ID</span>,
    }),
    columnHelper.accessor((row) => _.get(row, "subscriptions[0].subscriptionType"), {
      id: 'subscriptionType',
      cell: (info) => (
        <div className="truncate" style={{ maxWidth: 220 }}>
          {info.getValue()}
        </div>
      ),
      header: () => <span>Plan</span>,
    }),
    columnHelper.accessor('clientStatus', {
      id: 'clientStatus',
      cell: (info) => (
        <div className="truncate" style={{ maxWidth: 220 }}>
          <Badge bg={`${getBadge(info.getValue())}`}>{info.getValue()}</Badge>
        </div>
      ),
      header: () => <span>Status</span>,
    }),
  ];
  if (!isPopupMode && currentUserRole === "ADMIN") {
    columns.push(
      // columnHelper.display({
      //   id: 'actions',
      //   header: () => <span>Action</span>,
      //   cell: (info) => {
      //     const client = info.row.original;

      //     const handleDeactivate = () => {
      //       setSelectedClient(client);
      //       setShowModal(true);
      //     };

      //     return (
      //       <button
      //         className="btn btn-danger btn-sm"
      //         onClick={handleDeactivate}
      //         disabled={client.clientStatus?.toUpperCase() === 'DEACTIVATED'}
      //       >
      //         {client.clientStatus?.toUpperCase() === 'DEACTIVATED' ? 'Deactivate' : 'Deactivate'}
      //       </button>

      //     );
      //   },
      // })
      columnHelper.display({
        id: 'actions',
        header: () => <span>Action</span>,
        cell: (info) => {
          const client = info.row.original;
          const isDeactivated = client.clientStatus?.toUpperCase() === 'DEACTIVATED';

          const handleDeactivate = () => {
            setSelectedClient(client);
            setIsActivateAction(false);
            setShowModal(true);
          };

          const handleActivate = () => {
            setSelectedClient(client);
            setIsActivateAction(true);
            setShowModal(true);
          };

          return isDeactivated ? (
            <button className="btn btn-success btn-sm" onClick={handleActivate}>
              Activate
            </button>
          ) : (
            <button className="btn btn-danger btn-sm" onClick={handleDeactivate}>
              Deactivate
            </button>
          );
        },
      })
    );
  }
  return { columns, data };
};